(function(){
  'use strict';

  function qsa(root, sel){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function syncFooter(footer, expanded){
    if(!footer) return;
    footer.classList.toggle('is-summary-expanded', !!expanded);
    var toggle = footer.querySelector('[data-studio-footer-toggle]');
    if(toggle){
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute('aria-label', expanded ? 'Hide setup summary' : 'Show setup summary');
      var icon = toggle.querySelector('span');
      if(icon) icon.textContent = expanded ? '⌄' : '⌃';
    }
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-studio-footer-toggle]');
    if(!toggle) return;
    var footer = toggle.closest('[data-studio-footer]');
    if(!footer) return;
    e.preventDefault();
    syncFooter(footer, !footer.classList.contains('is-summary-expanded'));
  });

  document.addEventListener('DOMContentLoaded', function(){
    qsa(document, '[data-studio-footer]').forEach(function(footer){ syncFooter(footer, false); });
  });
})();

/* ST-R30 — Mobile PDP Studio controller (ST-R28 stable shell + architecture cleanup stage).
   Contract:
   - Desktop preview/rendering remains owned by the existing PDP Studio controllers.
   - Mobile Studio shell owns the viewport through the panel, not by fixing product-info or the gallery.
   - The mobile preview mounts inside [data-studio-mobile-preview].
   - The source preview remains the already-rendered gallery preview; this script only mirrors it.
*/
(function(){
  'use strict';

  function qs(root, sel){ return root ? root.querySelector(sel) : null; }
  function qsa(root, sel){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 749px)').matches; }
  function activeStudio(){ return document.querySelector('.studio.studio--pdp[data-studio-state="open"]'); }

  var locked = false;
  var savedY = 0;
  var syncTimer = null;
  var lastMirrorKey = '';

  var MOBILE_SHELL_TRANSITION_MS = 170;

  function mobileShellTransition(){
    function finishOpening(controller){
      var root = controller && controller.root;
      if(!root || !isMobile()) return;
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          root.classList.remove('is-studio-mobile-opening');
          document.documentElement.classList.remove('studio-mobile-opening');
          document.body.classList.remove('studio-mobile-opening');
        });
      });
    }

    function prepareOpen(controller){
      if(!controller || !isMobile()) return false;
      var root = controller.root;
      var panel = controller.panel;
      var info = controller.info;
      var trigger = controller.trigger;
      if(!root || !panel) return false;

      if(controller._studioMobileCloseTimer){
        clearTimeout(controller._studioMobileCloseTimer);
        controller._studioMobileCloseTimer = null;
      }

      root.classList.remove('is-studio-mobile-closing');
      root.classList.add('is-studio-mobile-opening');
      document.documentElement.classList.remove('studio-mobile-closing');
      document.body.classList.remove('studio-mobile-closing');
      document.documentElement.classList.add('studio-mobile-open','studio-mobile-opening');
      document.body.classList.add('studio-mobile-open','studio-mobile-opening');

      root.setAttribute('data-studio-state','open');
      if(trigger) trigger.setAttribute('aria-expanded','true');
      panel.hidden = false;
      if(info) info.classList.add('studio-active');
      return true;
    }

    function beginClose(controller, cleanup){
      if(!controller || !isMobile()) return false;
      var root = controller.root;
      var panel = controller.panel;
      var trigger = controller.trigger;
      if(!root || !panel || panel.hidden) return false;

      if(controller._studioMobileCloseTimer) clearTimeout(controller._studioMobileCloseTimer);
      root.classList.remove('is-studio-mobile-opening');
      root.classList.add('is-studio-mobile-closing');
      document.documentElement.classList.remove('studio-mobile-opening');
      document.body.classList.remove('studio-mobile-opening');
      document.documentElement.classList.add('studio-mobile-closing');
      document.body.classList.add('studio-mobile-closing');
      if(trigger) trigger.setAttribute('aria-expanded','false');

      controller._studioMobileCloseTimer = window.setTimeout(function(){
        controller._studioMobileCloseTimer = null;
        try{
          if(typeof cleanup === 'function') cleanup();
        } finally {
          root.classList.remove('is-studio-mobile-closing','is-studio-mobile-opening');
          document.documentElement.classList.remove('studio-mobile-closing','studio-mobile-opening');
          document.body.classList.remove('studio-mobile-closing','studio-mobile-opening');
        }
      }, MOBILE_SHELL_TRANSITION_MS);
      return true;
    }

    return { prepareOpen:prepareOpen, finishOpening:finishOpening, beginClose:beginClose };
  }

  window.BrilintonStudioMobileShellTransition = window.BrilintonStudioMobileShellTransition || mobileShellTransition();

  function setViewportVar(){
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight || 0;
    if(h > 0) document.documentElement.style.setProperty('--studio-mobile-vh', h + 'px');
  }

  function sectionIdFor(studio){ return studio ? studio.getAttribute('data-section-id') : ''; }

  function sourceHostFor(studio){
    var sectionId = sectionIdFor(studio);
    var gallery = sectionId ? document.getElementById('MediaGallery-' + sectionId) : null;
    var host = (gallery && (qs(gallery, '[data-studio-preview-host]:not([hidden])') || qs(gallery, '[data-studio-preview-host]'))) || null;
    if(host) return host;
    var localHost = studio && (qs(studio, '[data-studio-preview-host]:not([hidden])') || qs(studio, '[data-studio-preview-host]'));
    if(localHost) return localHost;
    var info = studio && (studio.closest('product-info') || studio.closest('.product'));
    return info && (qs(info, '[data-studio-preview-host]:not([hidden])') || qs(info, '[data-studio-preview-host]'));
  }

  function sourceRootFor(studio){
    var host = sourceHostFor(studio);
    return qs(host, '[data-studio-preview-root]');
  }

  function mobilePreviewFrameFor(studio){
    return qs(studio, '[data-studio-mobile-preview]');
  }

  function ensureStage(studio){
    var frame = mobilePreviewFrameFor(studio);
    if(!frame) return null;
    frame.classList.add('is-mounted');
    var stage = qs(frame, '.studio-mobile-preview-stage');
    qsa(document, '.studio-mobile-preview-stage').forEach(function(el){ if(el !== stage) el.remove(); });
    if(!stage){
      stage = document.createElement('div');
      stage.className = 'studio-mobile-preview-stage is-static-mirror is-dom-mirror';
      stage.setAttribute('aria-hidden', 'true');
      frame.appendChild(stage);
    }
    return stage;
  }

  function removeStage(){
    qsa(document, '.studio-mobile-preview-stage').forEach(function(el){ el.remove(); });
    qsa(document, '[data-studio-mobile-preview].is-mounted').forEach(function(el){ el.classList.remove('is-mounted'); });
    lastMirrorKey = '';
  }

  function activeScope(root){
    return qs(root, '[data-studio-preview="active"]') || qs(root, '[data-studio-side-stack="active"]') || qs(root, '.studio-preview__stack') || root;
  }

  function isVisiblePreviewImage(img){
    if(!(img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset'))) return false;
    var stack = img.closest('[data-studio-preview],[data-studio-side-stack]');
    if(stack){
      var preview = stack.getAttribute('data-studio-preview');
      var side = stack.getAttribute('data-studio-side-stack');
      if(preview && preview !== 'active') return false;
      if(side && side !== 'active' && side !== '') return false;
    }
    var layer = img.closest('.studio-preview__layer');
    if(layer && !layer.classList.contains('is-visible')) return false;
    var wrap = img.closest('.studio-preview__layer-wrap');
    if(wrap && wrap.classList.contains('is-hidden')) return false;
    var cs = window.getComputedStyle ? window.getComputedStyle(img) : null;
    if(cs && (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0)) return false;
    var r = img.getBoundingClientRect && img.getBoundingClientRect();
    return !!(r && r.width > 4 && r.height > 4);
  }

  function parsePxValue(value){
    var num = parseFloat(String(value || '').replace('px',''));
    return isFinite(num) ? num : null;
  }

  function inlineLayerBox(root){
    if(!root) return null;

    /* ST-R33: centre the actual assembled object, not the preview root.
       The source preview can be hidden on mobile, and active stack attributes can
       differ by controller. Therefore this intentionally reads every rendered
       Studio layer wrapper inside the root and filters by inline visibility and
       usable geometry, instead of trusting the root box or only one active-scope
       selector. */
    var wraps = qsa(root, '.studio-preview__layer-wrap').filter(function(wrap){
      var img = qs(wrap, 'img[data-layer]');
      if(!img || !((img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset')))) return false;

      var st = wrap.style || {};
      var imgSt = img.style || {};
      if(st.display === 'none' || st.visibility === 'hidden' || imgSt.display === 'none' || imgSt.visibility === 'hidden') return false;

      var l = parsePxValue(st.left), t = parsePxValue(st.top), w = parsePxValue(st.width), h = parsePxValue(st.height);
      return l != null && t != null && w != null && h != null && w > 4 && h > 4;
    });

    if(!wraps.length) return null;
    var left = Infinity, top = Infinity, right = -Infinity, bottom = -Infinity;
    wraps.forEach(function(wrap){
      var st = wrap.style || {};
      var l = parsePxValue(st.left), t = parsePxValue(st.top), w = parsePxValue(st.width), h = parsePxValue(st.height);
      left = Math.min(left, l);
      top = Math.min(top, t);
      right = Math.max(right, l + w);
      bottom = Math.max(bottom, t + h);
    });

    if(!isFinite(left) || !isFinite(top) || !isFinite(right) || !isFinite(bottom)) return null;
    var bw = right - left, bh = bottom - top;
    if(bw < 40 || bh < 40) return null;

    var pad = Math.max(10, Math.round(Math.min(bw, bh) * 0.035));
    return { x:left - pad, y:top - pad, w:bw + pad * 2, h:bh + pad * 2 };
  }

  function sourceVisualBox(root, host){
    var rootRect = (root && root.getBoundingClientRect && root.getBoundingClientRect()) || null;
    var hostRect = (host && host.getBoundingClientRect && host.getBoundingClientRect()) || null;
    var sourceW = rootRect && rootRect.width > 40 ? rootRect.width : parsePxValue(root && root.style && root.style.width);
    var sourceH = rootRect && rootRect.height > 40 ? rootRect.height : parsePxValue(root && root.style && root.style.height);
    if(!sourceW || sourceW < 40) sourceW = hostRect && hostRect.width > 40 ? hostRect.width : window.innerWidth;
    if(!sourceH || sourceH < 40) sourceH = hostRect && hostRect.height > 40 ? hostRect.height : Math.round(window.innerWidth * 0.92);

    /* Important: on mobile the source gallery preview can be hidden or have a zero
       DOM rect while the renderer has already written exact inline layer geometry.
       Use the layer geometry first; otherwise the mirror falls back to the full
       root box and the assembled product drifts left. */
    var inlineBox = inlineLayerBox(root);
    if(inlineBox){
      return {x:inlineBox.x, y:inlineBox.y, w:inlineBox.w, h:inlineBox.h, sourceW:sourceW, sourceH:sourceH};
    }

    if(!rootRect || rootRect.width < 40 || rootRect.height < 40){
      return {x:0, y:0, w:sourceW, h:sourceH, sourceW:sourceW, sourceH:sourceH};
    }

    var scope = activeScope(root);
    var imgs = qsa(scope, 'img').filter(isVisiblePreviewImage);
    if(!imgs.length) imgs = qsa(root, 'img').filter(isVisiblePreviewImage);
    if(!imgs.length) return {x:0, y:0, w:rootRect.width, h:rootRect.height, sourceW:rootRect.width, sourceH:rootRect.height};

    var rects = imgs.map(function(img){ return img.getBoundingClientRect(); }).filter(function(r){ return r && r.width > 4 && r.height > 4; });
    if(!rects.length) return {x:0, y:0, w:rootRect.width, h:rootRect.height, sourceW:rootRect.width, sourceH:rootRect.height};

    var left = Math.min.apply(null, rects.map(function(r){ return r.left; }));
    var top = Math.min.apply(null, rects.map(function(r){ return r.top; }));
    var right = Math.max.apply(null, rects.map(function(r){ return r.right; }));
    var bottom = Math.max.apply(null, rects.map(function(r){ return r.bottom; }));
    var pad = Math.max(14, Math.round(Math.min(right - left, bottom - top) * 0.045));
    var x = Math.max(0, left - rootRect.left - pad);
    var y = Math.max(0, top - rootRect.top - pad);
    var w = Math.min(rootRect.width - x, (right - left) + pad * 2);
    var h = Math.min(rootRect.height - y, (bottom - top) + pad * 2);
    if(!isFinite(w) || !isFinite(h) || w < 40 || h < 40){
      return {x:0, y:0, w:rootRect.width, h:rootRect.height, sourceW:rootRect.width, sourceH:rootRect.height};
    }
    return {x:x, y:y, w:w, h:h, sourceW:rootRect.width, sourceH:rootRect.height};
  }

  function previewKey(root, box, scale, frame){
    if(!root || !box) return '';
    var parts = [
      Math.round(box.x)+','+Math.round(box.y)+','+Math.round(box.w)+'x'+Math.round(box.h),
      's=' + scale.toFixed(3),
      'f=' + Math.round(frame.width) + 'x' + Math.round(frame.height)
    ];
    qsa(activeScope(root), '.studio-preview__layer-wrap,.studio-preview__layer').forEach(function(el){
      parts.push(el.className + ':' + (el.getAttribute('style') || ''));
    });
    qsa(activeScope(root), 'img').forEach(function(img){
      parts.push((img.getAttribute('data-studio-src-key') || img.getAttribute('data-b1-src-key')) || img.currentSrc || img.getAttribute('src') || img.getAttribute('srcset') || '');
      parts.push(img.className || '');
      parts.push(img.getAttribute('style') || '');
    });
    return parts.join('|');
  }

  function activeStackFor(root){
    if(!root) return null;
    return qs(root, '[data-studio-preview="active"]') ||
      qs(root, '[data-studio-side-stack="active"]') ||
      qs(root, '.studio-preview__stack') ||
      null;
  }

  function studioClassListWithoutMobile(root){
    var cls = String((root && root.className) || '').replace(/\bstudio-mobile-preview-root\b/g,'').replace(/\s+/g,' ').trim();
    return cls ? ' ' + cls : '';
  }

  function buildBoundedMobilePreview(root, box, scale){
    var stackSource = activeStackFor(root);
    if(!stackSource) return null;

    var object = document.createElement('div');
    object.className = 'studio-mobile-preview-object studio-product-preview' + studioClassListWithoutMobile(root);
    object.setAttribute('data-studio-preview-root', 'mobile-live');
    object.style.setProperty('--studio-mobile-object-w', box.w + 'px');
    object.style.setProperty('--studio-mobile-object-h', box.h + 'px');
    object.style.setProperty('--studio-mobile-object-scale', scale.toFixed(5));
    object.style.position = 'absolute';
    object.style.left = '50%';
    object.style.top = '50%';
    object.style.width = box.w + 'px';
    object.style.height = box.h + 'px';
    object.style.transform = 'translate(-50%, -50%) scale(' + scale.toFixed(5) + ')';
    object.style.transformOrigin = 'center center';
    object.style.pointerEvents = 'none';
    object.style.overflow = 'visible';

    var stack = stackSource.cloneNode(true);
    stack.removeAttribute('id');
    stack.classList.add('studio-mobile-preview-stack');
    stack.style.setProperty('position', 'absolute', 'important');
    stack.style.setProperty('left', '0px', 'important');
    stack.style.setProperty('top', '0px', 'important');
    stack.style.setProperty('width', box.w + 'px', 'important');
    stack.style.setProperty('height', box.h + 'px', 'important');
    stack.style.setProperty('max-width', 'none', 'important');
    stack.style.setProperty('max-height', 'none', 'important');
    stack.style.setProperty('aspect-ratio', 'auto', 'important');
    stack.style.setProperty('transform', 'none', 'important');
    stack.style.setProperty('transform-origin', 'left top', 'important');
    stack.style.setProperty('overflow', 'visible', 'important');

    qsa(stack, '.studio-preview__layer-wrap').forEach(function(wrap){
      var l = parsePxValue(wrap.style && wrap.style.left);
      var t = parsePxValue(wrap.style && wrap.style.top);
      if(l != null) wrap.style.setProperty('left', (l - box.x) + 'px', 'important');
      if(t != null) wrap.style.setProperty('top', (t - box.y) + 'px', 'important');
      wrap.style.setProperty('position', 'absolute', 'important');
      wrap.style.setProperty('right', 'auto', 'important');
      wrap.style.setProperty('bottom', 'auto', 'important');
      /* Preserve intentional layer transforms from the real preview engine.
         B¹ Link top adapters are rotated 180deg on desktop; wiping transform
         in the mobile mirror makes the upper link render upside-down/wrong. */
      var existingTransform = String((wrap.style && wrap.style.transform) || '').trim();
      wrap.style.setProperty('transform', (existingTransform && existingTransform !== 'none') ? existingTransform : 'none', 'important');
      wrap.style.setProperty('pointer-events', 'none', 'important');
    });

    qsa(stack, '.studio-preview__layer').forEach(function(img){
      img.style.setProperty('position', 'absolute', 'important');
      img.style.setProperty('left', '0px', 'important');
      img.style.setProperty('top', '0px', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('max-width', 'none', 'important');
      img.style.setProperty('max-height', 'none', 'important');
      img.style.setProperty('object-fit', 'contain', 'important');
      img.style.setProperty('object-position', 'center center', 'important');
      img.style.setProperty('transform', 'none', 'important');
    });

    object.appendChild(stack);
    return object;
  }

  function renderMirror(){
    setViewportVar();
    if(!isMobile()) { removeStage(); return; }

    var studio = activeStudio();
    if(!studio || !document.body.classList.contains('studio-mobile-open')){ removeStage(); return; }

    var host = sourceHostFor(studio);
    var root = sourceRootFor(studio);
    var stage = ensureStage(studio);
    var stageRect = stage && stage.getBoundingClientRect && stage.getBoundingClientRect();
    if(!root || !stage || !stageRect || stageRect.width < 40 || stageRect.height < 40){
      if(stage) stage.innerHTML = '';
      lastMirrorKey = '';
      return;
    }

    var box = sourceVisualBox(root, host);
    var cloneBox = inlineLayerBox(root);
    if(cloneBox && cloneBox.w > 40 && cloneBox.h > 40){
      box.x = cloneBox.x;
      box.y = cloneBox.y;
      box.w = cloneBox.w;
      box.h = cloneBox.h;
    }

    var fitW = stageRect.width * 0.94;
    var fitH = stageRect.height * 0.91;
    var scale = Math.min(fitW / box.w, fitH / box.h);
    if(!isFinite(scale) || scale <= 0) scale = 1;
    scale = Math.min(1.08, scale);

    var key = previewKey(root, box, scale, stageRect);
    var canvas = qs(stage, '.studio-mobile-preview-canvas');
    if(!canvas){
      canvas = document.createElement('div');
      canvas.className = 'studio-mobile-preview-canvas';
      stage.replaceChildren(canvas);
    }

    canvas.style.position = 'absolute';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.overflow = 'hidden';
    canvas.style.transform = 'none';

    if(key === lastMirrorKey && canvas.firstElementChild) return;
    lastMirrorKey = key;

    var object = buildBoundedMobilePreview(root, box, scale);
    if(!object){
      canvas.innerHTML = '';
      return;
    }
    canvas.replaceChildren(object);
  }

  function scheduleMirror(){
    clearTimeout(syncTimer);
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        renderMirror();
        syncTimer = setTimeout(renderMirror, 160);
      });
    });
  }

  function lockScroll(){
    if(!isMobile() || !activeStudio()) return;
    setViewportVar();
    document.documentElement.classList.add('studio-mobile-open');
    if(locked) return;
    savedY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.setAttribute('data-studio-scroll-y', String(savedY));
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    locked = true;
    try { window.dispatchEvent(new CustomEvent('brilinton:studio-mobile-lock', { detail: { scrollY: savedY } })); } catch(e) {}
  }

  function unlockScroll(){
    if(!locked && !document.body.classList.contains('studio-mobile-open')) return;
    var y = Number(document.body.getAttribute('data-studio-scroll-y') || savedY || 0);
    document.documentElement.classList.remove('studio-mobile-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.removeAttribute('data-studio-scroll-y');
    locked = false;
    removeStage();
    if(!activeStudio()){
      window.scrollTo(0, y);
      var notifyStudioUnlock = function(){
        try { window.dispatchEvent(new CustomEvent('brilinton:studio-mobile-unlock', { detail: { scrollY: y } })); } catch(e) {}
      };
      setTimeout(function(){ window.scrollTo(0, y); window.dispatchEvent(new Event('scroll')); window.dispatchEvent(new Event('resize')); notifyStudioUnlock(); }, 40);
      setTimeout(function(){ window.scrollTo(0, y); window.dispatchEvent(new Event('scroll')); window.dispatchEvent(new Event('resize')); notifyStudioUnlock(); }, 180);
      setTimeout(function(){ window.dispatchEvent(new Event('scroll')); window.dispatchEvent(new Event('resize')); notifyStudioUnlock(); }, 420);
    }
  }

  function syncLock(){
    if(isMobile() && activeStudio() && document.body.classList.contains('studio-mobile-open')) lockScroll();
    else if(!activeStudio()) unlockScroll();
  }

  function syncAccordionFocus(){
    var studio = activeStudio();
    qsa(document, '.studio.studio--pdp').forEach(function(s){
      s.classList.remove('studio-mobile-focus');
      qsa(s, '[data-studio-group].is-mobile-focused').forEach(function(g){ g.classList.remove('is-mobile-focused'); });
    });
    if(!isMobile() || !studio) return;
    var open = qsa(studio, '[data-studio-group]').find(function(group){
      if(group.hidden || group.closest('[data-studio-branch][hidden]')) return false;
      return group.getAttribute('data-open') === 'true';
    });
    if(open){
      studio.classList.add('studio-mobile-focus');
      open.classList.add('is-mobile-focused');
    }
  }

  function syncAll(){ syncLock(); syncAccordionFocus(); scheduleMirror(); }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-studio-trigger], [data-studio-close], [data-studio-summary], [data-studio-option], [data-studio-toggle]')){
      setTimeout(syncAll, 0);
      setTimeout(syncAll, 200);
      setTimeout(syncAll, 480);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function(){
    var mo = new MutationObserver(syncAll);
    mo.observe(document.body, {attributes:true, attributeFilter:['class'], subtree:false});
    qsa(document, '.studio.studio--pdp').forEach(function(studio){ mo.observe(studio, {attributes:true, attributeFilter:['data-studio-state']}); });
    syncAll();
  });

  window.addEventListener('load', syncAll, {passive:true});
  setTimeout(syncAll, 250);
  setTimeout(syncAll, 900);
  window.addEventListener('resize', syncAll, {passive:true});
  if(window.visualViewport) window.visualViewport.addEventListener('resize', syncAll, {passive:true});
})();
